import React, { useCallback, useEffect, useRef, useState, useMemo } from "react";
import classes from "./Birthday.module.css";
import { loadFull } from "tsparticles";
import Particles from "react-particles";
import AddWish from "../../components/Birthday/AddWish";
import { FIREBASE_URL } from "../../utils/Const";
import { Helmet } from "react-helmet";

const countDownDate = new Date("Jun 05, 2026 00:00:00").getTime();
// https://particles.js.org/docs/classes/Options_Classes_Particles_Shape_Shape.Shape.html#image
const BG_IMG_LIST = [
  `url('https://i.imgur.com/oLgjoWx.png')`,
  `url('https://i.imgur.com/oLgjoWx.png')`,
  `url('https://i.imgur.com/oLgjoWx.png')`,
];

const Birthday = () => {
  const [wishes, setWishes] = useState(["ahihi","xin chao"]);
  const [bgImg, setBGImg] = useState(BG_IMG_LIST[0]);
  const [isBd, setIsBd] = useState(false);
  const [showYT, setShowYT] = useState(false);
  const iframeRef = useRef(null);
  const particlesInit = useCallback(async (engine) => {
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {}, []);

  const [cd, setCd] = useState("");
  const [ch, setCh] = useState("");

  const [cm, setCm] = useState("");

  const countDownTimer = useCallback(() => {
    const x = setInterval(() => {
      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      setCd(String(days).padStart(2, "0"));
      setCh(String(hours).padStart(2, "0"));
      setCm(String(minutes).padStart(2, "0"));

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        setIsBd(true);
      }
    }, 1000);
    return () => clearInterval(x);
  }, []);

  const clock = () => {
    return (
      <div className={classes.countDownContainer}>
        <h4>Happy Birthday Party</h4>
        <div>
          <div className={classes.countdownSquare}>
            <h2>{cd?.charAt(0)}</h2>
          </div>
          <h3>day</h3>
        </div>
        <div className={classes.countdownSquare}>
          <h2>{cd?.charAt(1)}</h2>
        </div>

        <div className={classes.colon}>
          <h2>:</h2>
        </div>

        <div>
          <div className={classes.countdownSquare}>
            <h2>{ch?.charAt(0)}</h2>
          </div>
          <h3>hour</h3>
        </div>
        <div className={classes.countdownSquare}>
          <h2>{ch?.charAt(1)}</h2>
        </div>

        <div className={classes.colon}>
          <h2>:</h2>
        </div>

        <div>
          <div className={classes.countdownSquare}>
            <h2>{cm?.charAt(0)}</h2>
          </div>
          <h3>mins</h3>
        </div>
        <div className={classes.countdownSquare}>
          <h2>{cm?.charAt(1)}</h2>
        </div>
      </div>
    );
  };

  const requestWishes = async () => {
    try {
      const response = await fetch(FIREBASE_URL + "bd.json", {
        method: "GET",
      });
      const wishesRes = await response.json();      
      
      if (wishesRes) {
        const newWishes = Object.values(wishesRes)
          .map((wish: any) => wish?.text)
          .filter(Boolean);
        
        // Batch update instead of multiple state calls
        setWishes((prevState) => [...prevState, ...newWishes]);
      }
    } catch (error) {
      console.error("Error fetching wishes:", error);
    }
  };

  useEffect(() => {
    // Run countdown timer
    const cleanupCountdown = countDownTimer();

    // Fetch wishes
    requestWishes();

    // Background image rotation - cleanup properly
    const bgInterval = setInterval(() => {
      const randomNumber = Math.floor(Math.random() * BG_IMG_LIST.length);
      setBGImg(BG_IMG_LIST[randomNumber]);
    }, 5000);

    // Single timeout for YouTube iframe visibility
    const ytTimeout = setTimeout(() => {
      setShowYT(true);
      iframeRef?.current?.click();
    }, 2000);

    return () => {
      // Cleanup all intervals and timeouts
      if (cleanupCountdown) cleanupCountdown();
      clearInterval(bgInterval);
      clearTimeout(ytTimeout);
    };
  }, [countDownTimer]);

  const isShowWhenBd = () => {
    if (isBd) {
      return <h2>{``}</h2>;
    }
  };

  const isShowWhenCountDown = () => {
    if (!isBd) {
      return <div>{clock()}</div>;
    }
  };

  const onAdd = (wish) => {
    setWishes((prevState) => {
      return [...prevState, wish];
    });
  };

  const particleWishes = useMemo(() => {
    // Limit wishes to max 15 to avoid performance issues
    return wishes.slice(0, 15);
  }, [wishes]);

  const particlesOptions = useMemo(
    () => ({
      name: "Background Mask",
      fullScreen: {
        enable: true,
        zIndex: -1,
      },
      particles: {
        number: {
          value: Math.min(particleWishes.length, 15),
          density: {
            enable: true,
          },
        },
        color: {
          value: "#fff",
        },
        shape: {
          type: ["character"],
          options: {
            character: {
              value: particleWishes,
              font: "Verdana",
              style: "",
              weight: "",
            },
          },
        },
        opacity: {
          value: 0.9,
        },
        size: {
          value: {
            min: 5,
            max: 10,
          },
        },
        links: {
          enable: true,
          distance: 160,
          color: "#ac0e77",
          opacity: 1,
          width: 1,
        },
        move: {
          enable: true,
          speed: 1.5,
          direction: "bottom",
          random: false,
          straight: false,
        },
      },
      interactivity: {
        events: {
          onHover: {
            enable: true,
            mode: ["bubble"],
          },
          onClick: {
            enable: true,
            mode: "push",
          },
        },
        modes: {
          bubble: {
            distance: 250,
            size: 20,
            duration: 2,
            opacity: 0.8,
          },
          push: {
            quantity: 1,
          },
        },
      },
      backgroundMask: {
        enable: false,
        cover: {
          value: {
            r: 221,
            g: 180,
            b: 234,
          },
        },
      },
      background: {
        color: "#000",
        image: bgImg,
        position: "center",
        repeat: "repeat",
        size: "cover",
      },
    }),
    [particleWishes, bgImg]
  );

  return (
    <div className={classes.container}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Birthday</title>
        <meta name="description" content="Hua Cat Luong React JS projects" />
      </Helmet>
      <h1>Happy Birthday!</h1>
      {isShowWhenBd()}
      {isShowWhenCountDown()}

      {showYT ? (
        <iframe
          className="video"
          ref={iframeRef}
          title="Youtube player"
          sandbox="allow-same-origin allow-forms allow-popups allow-scripts allow-presentation"
          src={`https://youtube.com/embed/p6EjUkQ3Ut0?autoplay=1`}
          width="40"
          height="40"
          style={{ position: "absolute", right: 10, bottom: 10 }}
          allow="autoplay"
        ></iframe>
      ) : null}

      <AddWish onAdd={onAdd} />

      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={particlesOptions as any}
      />
    </div>
  );
};

export default Birthday;
